<template>
  <div>
    <div class="launch-content" v-if="isShowList">
      <Ad activeType="projectOrder">
        <span slot="projectOrder">
          <List @create="handleCreate" @read="handleRead" @edit="handleEdit" ref="list" />
        </span>
      </Ad>
    </div>
    <div v-if="!isShowList && mode !== 'read'">
      <Add  :id="id" :init-mode="mode"  @go-back="handleGoBack" ></Add>
    </div>
  </div>
</template>
<script>
import Ad from '@/components/Ad'
import List from './ProjectOrderList'
import Add from './ProjectOrderAdd'
export default {
  components: {
    List,
    Add,
    Ad
  },
  props: ['add'],
  data() {
    return {
      isShowList: true,
      id: undefined,
      mode: 'create'
    }
  },
  methods: {
    handleCreate() {
      this.id = undefined
      this.mode = 'create'
      this.isShowList = false
    },
    handleRead(item) {
      this.isShowList = false
      this.id = item.orderId
      this.mode = 'read'
    },
    handleEdit(item) {
      this.isShowList = false
      this.id = item.orderId
      this.mode = 'edit'
    },
    handleDelete() {
      this.isShowList = true
    },
    handleGoBack(item) {
      this.isShowList = true
      this.mode = 'list'
    }
  },
  created() {
    if (this.add) {
      this.handleCreate()
    }
  }
}
</script>
